module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Por proyecto":"Por proyecto","Proyecto":"Proyecto","Asignado":"Asignado","Recibido":"Recibido","Diferencia":"Diferencia","Guardar":"Guardar"},"en":{},"ca":{"Por proyecto":"Per projecte","Proyecto":"Projecte","Asignado":"Assignat","Recibido":"Rebut","Diferencia":"Diferència"}}')
  delete Component.options._Ctor
}
